// @ts-check
import {
  ADD_FLASH_MESSAGE,
  DISMISS_FLASH_MESSAGE,
} from 'shared/actions/UnboundFlashMessageActions';

const initialState = {
  id: undefined,
  isOpen: false,
  title: undefined,
  message: undefined,
  flashType: undefined,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_FLASH_MESSAGE: {
      const { id, title, message, flashType } = action;
      return {
        ...state,
        isOpen: true,
        id,
        title,
        message,
        flashType,
      };
    }
    case DISMISS_FLASH_MESSAGE: {
      const { id } = action;
      return {
        ...state,
        isOpen: state.id === id ? false : state.isOpen,
      };
    }
    default:
      return state;
  }
}
